import { TableCell, TableRow, Button } from '@/components/ui';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { FileJson } from 'lucide-react';
import { ActionBadge } from './ActionBadge';
import type { IAuditLog } from '@/interfaces';

interface Props {
	log: IAuditLog;
	onViewSnapshot: (log: IAuditLog) => void;
}

const truncate = (str: string, len = 16) =>
	str.length > len ? `${str.slice(0, len)}…` : str;

export const DataTableDesktopRow = ({ log, onViewSnapshot }: Props) => (
	<TableRow className="h-12 font-mono text-xs">
		<TableCell className="text-muted-foreground">
			{format(new Date(log.createdAt), 'dd/MM/yyyy HH:mm', { locale: fr })}
		</TableCell>
		<TableCell>
			<ActionBadge action={log.action} />
		</TableCell>
		<TableCell className="text-muted-foreground">{log.entityType}</TableCell>
		<TableCell>
			<span title={log.entityId} className="cursor-default">
				{truncate(log.entityId, 18)}
			</span>
		</TableCell>
		<TableCell>
			<span title={log.performedByUserId} className="cursor-default">
				{log.performedByUserName ?? truncate(log.performedByUserId, 18)}
			</span>
		</TableCell>
		<TableCell className="text-right">
			{log.snapshot && (
				<Button
					variant="ghost"
					size="icon"
					className="h-8 w-8"
					onClick={() => onViewSnapshot(log)}
					title="Voir le snapshot"
				>
					<FileJson size={14} />
				</Button>
			)}
		</TableCell>
	</TableRow>
);
